<template>
  <div class="w100 pl20 bg-w pr20 pt20 pb20" v-loading="loading">
    <!--<Sift ref="needSift" :sift-data="siftData" v-if="siftData.length" @change="initPage">-->
      <!--<el-col class="flex-box al-c" :span="4">-->
        <!--<el-button type="primary" @click="initPage">查询</el-button>-->
      <!--</el-col>-->
    <!--</Sift>-->

    <div class="table-con">
      <el-table class="w100 mt20  table"stripe :data="list" height="calc(100vh - 200px)">
        <!--<el-table-column align="center" label="序号" width="50px">-->
          <!--<template slot-scope="scope">-->
            <!--{{ paramSearch.current * paramSearch.size - paramSearch.size + scope.$index + 1 }}-->
          <!--</template>-->
        <!--</el-table-column>-->
        <el-table-column align="center" width="200px"   label="服务名称">
          <template slot-scope="scope">
            <div>
              <el-image
                      class="img-warp"
                      :src="scope.row.fileUrl"
                      fit="contain">
              </el-image>
              <div  v-text="scope.row.serveName"></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="intro"  width="200px" label="服务简介"></el-table-column>
        <el-table-column align="center" prop="deptName"  width="200px" label="责任部门"></el-table-column>
        <el-table-column align="center" label="服务主题" width="200px">
          <template slot-scope="scope">
            <div>{{(scope.row.serveSubject||[]).join("、")}}</div>
          </template>
        </el-table-column>
        <el-table-column align="center"  label="服务对象"  width="200px">
          <template slot-scope="scope">
           <div>{{(scope.row.serveTarget||[]).join("、")}}</div>
          </template>
        </el-table-column>
        <el-table-column align="center"  label="办理途径" width="100px" >
          <template slot-scope="scope">
            <div>{{scope.row.applyType | formatApplyType}}</div>
          </template>
        </el-table-column>
        <el-table-column align="center"  width="240px"  label="操作" fixed="right">
          <template slot-scope="scope">
            <div class="to-use">
              <div>
                <span class="allow" @click="goHref(scope.row.serveId,'/ServeCenterDetail')">办事指南</span>
                <span  :class="[(scope.row.applyType==1||scope.row.applyType==3)?'allow':'refused']"
                       @click="(scope.row.applyType==1||scope.row.applyType==3)&&HandleApply(scope.row);">线上办理</span>
              </div>
              <div>
                <span class="allow" @click="favorOrRecall(scope.row)">取消收藏</span>
                <span  class="allow"  @click="goHref(scope.row.serveId,'/serveEvaluate')">好差评</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="mt20 flex-box">
      <div class="flex-1"></div>
      <el-pagination background @size-change="changeSize"
                     @current-change="changePage"
                     :current-page="paramSearch.current"
                     :page-sizes="pageSizes"
                     :page-size="paramSearch.size"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
    import Sift from "@/components/sift/Sift";
    import { getCollectionList} from '@/api/personalCenter/myCollection';
    import {favorOrRecall} from '@/api/serveCenter/serveCenter';
    import { bpmnStartProcess} from '@/api/bpmnApi/bpmn';

    export default {
        name: "Collect",
        components: {
            Sift,
        },
        props: [],
        data() {
            return {
                loading: false,
                siftData : [
                    {
                        type: "text",
                        key: "name",
                        label: "服务名称",
                        placeholder: "请输入服务名称",
                        default: ""
                    }
                ],
                list: [],
                pageSizes:[10, 20, 30, 50, 100],
                paramSearch:{
                    current:1,
                    size:10,
                    name:''
                },
                total: 0
            };
        },
        computed: {},
        created() {},
        mounted() {
            this.getListFn();
        },
        methods: {
            HandleApply(item){
                let processDefId=item.processDefId;
                bpmnStartProcess({processDefId}).then(({data})=>{
                    if(data.code==0){
                        // this.$refs.IframeView.showView(data.data);
                        window.open(data.data.url);
                    }else{
                        this.$message.warning(data.msg||'流程系统业务忙，请刷新或者重新操作');
                    }

                }).catch(err=>{
                    this.$message.error("服务异常" );
                })


            },
            goHref(id,name){
                let routeData = this.$router.resolve({
                    name,
                    query: {id}
                });
                window.open(routeData.href);
            },
            // 获取查询列表
            getListFn () {
                this.loading = true;
                getCollectionList(this.paramSearch).then(({data})=> {
                    this.loading = false;
                    if(data.code == 0){
                        this.list = data.data.records || [];
                        this.total = data.data.total;
                    }
                })
                    .catch(() => {
                        this.loading = false;
                    });
            },
            // 默认页面数据
            initPage() {
                this.paramSearch={
                    ...this.paramSearch,
                    ...this.$refs.needSift.getValue(),
                    current:1
                }
                this.getListFn();
            },

            // 条数
            changeSize(value) {
                this.paramSearch.size=value;
                this.paramSearch.current=1;
                this.getListFn();
            },
            // 翻页
            changePage(value) {
                this.paramSearch.current=value;
                this.getListFn();
            },
            goInfo(id){
                this.$router.push({path:'/ServeCenterDetail',query:{id}})

            },

            favorOrRecall(item){
                const params={
                    isFavor:false,
                    serveId:item.serveId
                }
                this.loading = true;
                favorOrRecall(params).then(({data})=>{
                    this.loading = false;
                    if(data.code == 0){
                        this.$message.success( "取消收藏成功!");
                        this.getListFn();
                    }else{
                        this.$message.warning(data.msg||"操作失败!" );
                    }


                }).catch(err=>{
                    this.loading = false;
                })


            }

        },
        watch: {},
        filters: {
            formatApplyType(val){
                let obj= {
                    "1":"线上",
                    "2":"线上",
                    "3":"线上和线下"
                }
                return obj[val+'']
            },
        }
    };
</script>

<style scoped  lang="less">
  .table-con {
    .img-warp{
      width: 40px;
      height: 40px;
      cursor: pointer
    }
    .to-use{
      span{
        display: inline-block;
        width: 70px;
        height: 26px;
        line-height: 31px;
        margin: 3px 3px;
        font-size: 14px;
        background: #F1F2F4;
        &.allow:hover{
          color: white!important;
          cursor: pointer;
        }
        &.refused{
          cursor:not-allowed;
          color: #ccc;
        }
      }

    }
  }

</style>
